var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "audio-box f fc" },
    [
      _c("van-slider", {
        attrs: {
          "bar-height": "2px",
          "button-size": "12px",
          "active-color": "#fff",
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.playerValue,
          callback: function ($$v) {
            _vm.playerValue = $$v
          },
          expression: "playerValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }